// Author: Sunil Jain
// Timestamp: 2025-04-30 05:20:00 PM EDT
// File: src/utils/enums.js
// Description: Frontend enums, mirroring backend definitions.
// Change: Added UserRole enum.

// Mirrors UserRole enum from backend models.py
export const UserRole = Object.freeze({
    PATIENT: "patient",
    PHYSICIAN_QHP: "physician_qhp",
    CLINICAL_STAFF: "clinical_staff",
    TENANT_ADMIN: "tenant_admin",
    PLATFORM_ADMIN: "platform_admin",
    SUPER_USER: "super_user",
});

// Locate SurveyCategoryEnum and add the new key at the end
export const SurveyCategoryEnum = {
    PRO: 'patient_reported_outcome',
    PATIENT_SATISFACTION: 'patient_satisfaction',
    INTAKE_ADMIN: 'intake_administrative',
    HEALTH_WELLNESS_ASSESSMENT: 'health_wellness_assessment',
    CLINICAL_CHECKLIST: 'clinical_checklist',
    ADHERENCE_EMPATHIZER: 'adherence_empathizer',
    OTHER_CLINICAL: 'other_clinical',
    REHABILITATIVE_EXERCISE: 'rehabilitative_exercise',
    CLINICAL_DATA_COLLECTION: 'CLINICAL_DATA_COLLECTION' // New line
};

export const BillingCodeCategory = Object.freeze({
    // RTM Categories
    RTM_SETUP: "RTM_SETUP",
    RTM_DEVICE_SUPPLY: "RTM_DEVICE_SUPPLY",
    RTM_MONITORING_MGMT: "RTM_MONITORING_MGMT",
    RTM_INTERACTIVE: "RTM_INTERACTIVE", // May be deprecated if using flag on RTM_MONITORING_MGMT

    // PCM Categories
    PCM_SERVICE: "PCM_SERVICE", // Combined QHP codes for simplicity in FE? Or use specific codes?
    PCM_STAFF_SERVICE: "PCM_STAFF_SERVICE",
    PCM_CARE_PLANNING: "PCM_CARE_PLANNING",

    // CCM Categories
    CCM_SERVICE: "CCM_SERVICE", // Combined initial/addl codes for simplicity?
    CCM_COMPLEX: "CCM_COMPLEX",
    CCM_CARE_PLANNING: "CCM_CARE_PLANNING",

    // CPM Categories
    CPM_SERVICE: "CPM_SERVICE", // Combined G3002/G3003

    // Telehealth / eVisit
    EVISIT_SERVICE: "EVISIT_SERVICE", // Combined 99421-99423
    TELEHEALTH: "TELEHEALTH", // Generic for telehealth encounters

    // eConsults
    ECONSULT_REQUEST: "ECONSULT_REQUEST",   // Combined 99446-99449
    ECONSULT_RESPONSE: "ECONSULT_RESPONSE", // Combined 99451/99452

    // TCM Codes
    TCM_NONFACE2FACE: "TCM_NONFACE2FACE",
    TCM_CONTACT_EVENT: "TCM_CONTACT_EVENT",
    TCM_MEDREC_EVENT: "TCM_MEDREC_EVENT",
    TCM_VISIT_EVENT: "TCM_VISIT_EVENT", // To log F2F visit completion

    // General Time
    OTHER_TIME_LOGGED: "OTHER_TIME_LOGGED"
});

export const PriorAuthStatus = Object.freeze({
    NOT_REQUIRED: "not_required",
    REQUIRED_PENDING: "required_pending",
    SUBMITTED: "submitted",
    APPROVED: "approved",
    DENIED: "denied",
    APPEALED: "appealed",
    EXPIRED: "expired",
    INFO_REQUESTED: "info_requested"
});

export const CareTeamMemberRole = Object.freeze({
    PRIMARY_PHYSICIAN: "primary_physician",
    CONSULTING_PHYSICIAN: "consulting_physician",
    CARE_MANAGER: "care_manager",
    CLINICAL_STAFF: "clinical_staff",
    ADMINISTRATIVE_STAFF: "administrative_staff",
    PATIENT_NAVIGATOR: "patient_navigator"
});


console.log("--- Frontend Enums (enums.js) loaded ---"); // Simplified log message